<template>
    <div>
        <div class="form" v-if="$route.path == '/SendGoods/ViewSendGoodsForStock' || $route.path == '/SendGoods/ViewSendGoodsForResourcePackage'">
            <el-form style="margin:20px;width:70%;min-width:600px;" label-width="180px">
                <el-form-item class='edit-form' label="销售下单号">
                    <span>{{Form.OrderCode}}</span>
                    <el-button @click="printSendGooods" style="margin-left: 350px">打印发货通知单</el-button>
                </el-form-item>
                <el-form-item class='edit-form' label="发货通知单号">
                    <span>{{Form.SendCode}}</span>
                </el-form-item>

                <el-form-item class='edit-form' label="代理商" style="width:100%">
                    <span>{{Form.AgentCode}} &nbsp; {{Form.AgentName}} &nbsp; {{Form.AgentAddress}} &nbsp; {{Form.AgentTel}}</span>
                </el-form-item>

                <el-form-item class='edit-form' label="业务员">
                    <span>{{Form.SaleEmployeeName}}</span>
                </el-form-item>

                <div v-show="orderTypeShow">
                    <el-form-item class='edit-form' label="申请时间">
                        <span>{{Form.ApplyTime}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form' label="期望上课日期">
                        <span>{{Form.StartDate}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form' label="园所名称">
                        <span>{{Form.SchoolName}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form' label="课程名称">
                        <span>{{Form.OrderTitle}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form' label="幼儿数">
                        <span>{{Form.ChildNum}}</span>
                    </el-form-item>
                    <el-form-item label="开课申请表:">
                        <el-row style="margin-left: 25px;" v-if="JSON.stringify(Form.ApplicationForm)!='[]'">
                            <el-col :span="3" v-for="item in Form.ApplicationForm" style="margin-right:25px;margin-top:10px">
                                <div style="width:100%;border:4px solid RGB(205,205,205);border-radius:3px;line-height:0px;">
                                    <img :src="item.Url" style="width:100%;display:block" @click="viewpic(item.Url)">
                                </div>
                            </el-col>
                        </el-row>
                        <span v-else>--</span>
                    </el-form-item>
                    <el-form-item class='edit-form' label="观课人数" v-show="isShowGK">
                        <span>{{Form.Attendance}}</span>
                    </el-form-item>
                </div>

                <el-form-item class='edit-form' label="套餐名称" v-show="Form.PackageName!=''">
                    <span>{{Form.PackageName}}</span>
                </el-form-item>

                <el-form-item class='edit-form' label="商品" v-show="Form.ListGoods!=''" style="width:900px">
                    <el-table :data="Form.ListGoods" border style="width: 80%;  margin-left: 25px;">
                        <el-table-column prop="ProName" label="名称">
                        </el-table-column>
                        <el-table-column label="包含单品" width="240">
                            <template scope="scope">
                                <div v-if="scope.row.PackDetail.length==0">--</div>
                                <div v-else class="dpDvCtnCss">
                                    <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ProductNum" label="订单数" v-if="isShow"></el-table-column>
                        <el-table-column prop="SendNum" label="通知数" v-if="isShow"></el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item class='edit-form' label="发货情况">
                    <span>{{Form.DeliveryStatusName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="赠品" v-show="Form.GiftGoods!=''" style="width:900px">
                    <el-table :data="Form.GiftGoods" border style="width: 80%;  margin-left: 25px;">
                        <el-table-column prop="ProName" label="名称">
                        </el-table-column>
                        <el-table-column label="包含单品" width="240">
                            <template scope="scope">
                                <div v-if="scope.row.PackDetail.length==0">--</div>
                                <div v-else class="dpDvCtnCss">
                                    <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ProductNum" label="订单数" v-if="isShow"></el-table-column>
                        <el-table-column prop="SendNum" label="通知数" v-if="isShow"></el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item class='edit-form' label="收货地址" style="width:100%">
                    <span>{{Form.AgentConsignee}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="收货人及联系方式">
                    <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="寄送方式">
                    <span>{{Form.SendModeName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="支付方式">
                    <span>{{Form.PayModeName}}</span>
                </el-form-item>
                <el-form-item class="edit-form" label="订单备注">
                    <span v-if="Form.OrderRemark!=''">{{Form.OrderRemark}}</span>
                    <span v-else>--</span>
                </el-form-item>
                <el-form-item class="edit-form" label="财务审核备注">
                    <span v-if="Form.OrderRemark!=''">{{Form.AuditRemark}}</span>
                    <span v-else>--</span>
                </el-form-item>
                <el-form-item class='edit-form' label="">
                    <el-button :plain="true" type="info" @click="goBack()">我知道了</el-button>
                </el-form-item>
            </el-form>
            <div class="picshow">
                <el-dialog v-model="picVisible" size="tiny">
                    <img :src="picUrl" alt="">
                </el-dialog>
            </div>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import NProgress from 'nprogress';
import { ViewSendGoodsForStock } from '@api/sendGoodsApi.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';

module.exports = {
    data() {
        return {
            Form: {},
            picVisible: false,
            picUrl: ""
        }
    },
    computed: {
        isShow() {
            if ($.trim(this.$route.path).indexOf('/SendGoods/ViewSendGoodsForStock') > -1) {
                let orderType = $.trim(this.Form.OrderType);
                let PackageId = this.Form.PackageId;
                if (orderType.indexOf("ZS") > -1 || orderType.indexOf("SC") > -1 || ("111,112,113").indexOf(PackageId) > -1) {
                    return true;
                }
                return false;
            }
            return true;
        },
        orderTypeShow() {
            //OrderType
            //SO GK
            let orderType = $.trim(this.Form.OrderType);
            if (orderType.indexOf("SO") > -1 || orderType.indexOf("GK") > -1 || orderType.indexOf("SU") > -1) {
                return true;
            }
            return false;
        },
        isShowGK() {
            let orderType = $.trim(this.Form.OrderType);
            if (orderType.indexOf("GK") > -1) {
                return true;
            }
            return false;
        }
    },
    methods: {
        viewpic(val) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{ src: val, id: "" }]
            });
        },
        printSendGooods() {
            //util.redirect(this, '/SendGoods/ViewSendGoodsForStock/SendGoodsPage?Id=' + this.$route.query.Id, false);
            util.redirect(this, '/SendGoods/ViewSendGoodsForStock/SendGoodsForCKPage?Id=' + this.$route.query.Id, false);
        },
        goBack() {
            window.history.go(-1);
        }
    },
    created: function() {
        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                Id: this.$route.query.Id
            };
            ViewSendGoodsForStock(para).then(res => {
                util.doResult(this, res, () => {
                    let Data = res.data.Data;
                    this.Form = [];
                    this.Form = Data;
                });
            });
        }
    }
}
</script>
<style scoped lang="scss">
span {
    margin-left: 25px;
}

.dpDvCss {
    border-bottom: 1px solid #ccc;
    line-height: 34px;
}

.dpDvCtnCss .dpDvCss:last-child {
    border: 0px!important;
}
</style>


// WEBPACK FOOTER //
// ViewSendGoodsForStock.vue?e14a3b14